var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stockorder',{key:_vm.key,attrs:{"stockorders":_vm.stockOrders,"suppliers":_vm.supplierOrganisations,"devicemakemodels":_vm.deviceMakeModels,"stockitems":_vm.stockItems,"stocktypes":_vm.stockTypes,"couriers":_vm.couriers,"warehouses":_vm.warehouses},on:{"stockOrderChange":function($event){return _vm.getStockOrders()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }